<template>
  <div>
    <vue-headful
      title="Create new question"
      description="Description goes here"
    />

    <!-- CREATE QUESTION SECTION -->
    <div class="create-question-section">
      <!-- TOP SECTION -->
      <div class="top-section">
        <div class="container px-md-0">
          <div class="row">
            <div
              class="col-12 d-flex justify-content-between align-items-center"
            >
              <!-- LEFT -->
              <div class="left d-flex justify-content-start align-items-center">
                <!-- AVATAR ICON -->
                <div class="avatar go-back pointer">
                  <router-link :to="{ name: route_link }">
                    <span class="icon-caret-left brand_navy flex-center"></span>
                  </router-link>
                </div>
                <!-- ASSESSMENT INFO -->
                <div class="assessment-info">
                  <div class="title brand_navy font-weight-bold">
                    Preview Questions
                  </div>
                  <div
                    class="duration color_grey_dark"
                    v-html="assessment_details.title"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- TOP SECTION -->

      <!-- CONTENT -->
      <div class="content-section-area">
        <div class="container">
          <div class="row">
            <!-- SELECTION ROW  -->
            <div
              class="w-100 selection-row d-flex justify-content-center align-items-start flex-nowrap"
              v-if="!$route.query.action"
            >
              <router-link to class="selection-column active-column"
                >Create Questions</router-link
              >
              <router-link
                :to="{ name: 'TeacherBulkQuestion' }"
                class="selection-column"
                >Upload Questions</router-link
              >
            </div>

            <!-- INTRO TEXT -->
            <div
              class=" col-12 top-row d-flex justify-content-center align-items-start nowrap"
            >
              <div class="left-row">
                <div class="title-text font-weight-bold color_text text-center">
                  Create Questions
                </div>
                <div class="meta-text color_text mb-3 text-center">
                  Create as many questions as you want for this assessment
                </div>
              </div>
            </div>
            <!-- INTRO TEXT -->

            <AuthAlertCard
              v-if="alert.show"
              :alert_type="alert.type"
              :alert_msg="alert.msg"
              class="mb-4"
            />

            <!-- QUESTION ACCORDION COMPONENT -->
            <div class="col-12">
              <!-- NEW QUESTIONS -->
              <QuestionAccordion
                v-if="assessment_questions.length === 0"
                :question="{}"
                :question_index="0"
                @closeTriggered="toggleSelectTopic"
              />

              <!-- POPULATED QUESTIONS -->
              <QuestionAccordion
                v-else
                :questions="assessment_questions"
                @closeTriggered="toggleSelectTopic"
              />
              <!-- QUESTION ACCORDION COMPONENT -->
            </div>
          </div>
        </div>
      </div>
      <!-- CONTENT -->

      <!-- BOTTOM SECTION -->
      <div class="bottom-row-section">
        <div class="container">
          <div class="row">
            <div
              class="col-12 d-flex justify-content-between align-items-center"
            >
              <!-- CANCEL BUTTON -->
              <button
                @click="returnToCreateAssessment"
                class="btn btn-md z-depth-0 transparent_bg brand_navy"
              >
                Cancel
              </button>

              <button
                @click="returnToCreateAssessment"
                class="btn btn-md btn-primary"
                :disabled="disablePublishButton"
              >
                Add to
                {{ getAssessmentType ? getAssessmentType : "Assessment" }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- BOTTOM SECTION -->
    </div>
    <!-- MODAL -->
    <SelectTopicModal
      v-if="select_topic_modal"
      @closeTriggered="toggleSelectTopic"
      @listSelected="updateTopicList($event)"
    ></SelectTopicModal>
    <!-- MODAL -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { bgColorSetter } from "@/scripts/utilities";
import QuestionAccordion from "@/components/classComps/assessment/QuestionAccordion";
import SelectTopicModal from "@/components/modalComps/assessmentModals/SelectTopicModal";
import AuthAlertCard from "@/components/globalComps/AuthComps/AuthAlertCard";

export default {
  name: "CreateQuestion",

  components: {
    AuthAlertCard,
    QuestionAccordion,
    SelectTopicModal,
  },

  computed: {
    ...mapGetters(["getCurrentHomeWorkId", "getCurrentlySelectHomework"]),

    disablePublishButton() {
      return this.assessment_questions.length === 0 ? true : false;
    },

    getAssessmentType() {
      return JSON.parse(localStorage.homework).tag;
    },
  },

  update() {
    console.log("updated");
  },

  watch: {
    add_question(val) {
      if (val) this.update_question = {};
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      route_link: "",
      select_topic_modal: false,
      isAttaching: false,
      add_new_question: false,
      show_new_quesition: false,
      // topic_list: [],
      action: "create",
      selected_question: {},
      questions: [],
      alert: {
        show: false,
        type: "",
        msg: "",
      },
      assessment_questions: [],
      assessment_details: {},
    };
  },

  mounted() {
    bgColorSetter("#F0F0F0");
    this.loadQuestionSet();
    console.log(this.$route);
  },

  methods: {
    ...mapActions([
      "getQuestionsInHomework",
      "removeQuestionFromHomework",
      "addQuestionsToHomework",
    ]),

    ...mapMutations(["SET_CURRENT_HOMEWORK"]),

    returnToCreateAssessment() {
      if (this.account_type === "school") {
        this.$router.replace({
          name: "ManageSchoolAssessment",
        });
      } else if (this.account_type === "teacher") {
        this.$router.replace({
          name: "ManageTeacherAssessment",
        });
      }
    },

    loadQuestionSet() {
      this.assessment_details = JSON.parse(localStorage.homework);

      this.fetchQuestions();
      this.action = this.$route.query.action || "create";
    },

    toggleSelectTopic() {
      this.select_topic_modal = !this.select_topic_modal;
    },

    toggleNewQuestion() {
      this.show_new_quesition = true;
    },

    addNewQuestion() {
      this.add_new_question = true;
    },

    updateTopicList($event) {
      this.topic_list = $event.topics;
      // console.log(this.topic_list);
    },

    updateView(index) {
      this.assessment_questions.map((question) => (question.view = "minim"));
      this.selected_question = this.assessment_questions[index].view = "maxim";
    },

    fetchQuestions() {
      this.getQuestionsInHomework(this.getCurrentHomeWorkId)
        .then((response) => {
          // console.log(response);
          if (response.code === 200) {
            this.questions = response.data;
            this.assessment_questions = this.questions.map((item) => {
              return {
                // view: (index === 0) ? 'maxim' : 'minim',
                view: "minim",
                id: item.id,
                question: item.question,
                option_a: item.option_a,
                option_b: item.option_b,
                option_c: item.option_c,
                option_d: item.option_d,
                option_e: item.option_e,
                answer: item.answer,
                duration: item.duration,
                difficulty: item.difficulty,
                type: item.type,
              };
            });

            if (
              this.$route.query.action === "edit" &&
              this.$route.query.id !== null
            ) {
              this.selected_question = this.questions.find((item) => {
                if (item.id === this.$route.query.id) {
                  // this.assessment_questions[index].view = "maxim";
                  return item;
                }
              });
            }
          }

          if (this.account_type === "school") {
            this.route_link =
              this.assessment_questions.length === 0
                ? "SchoolContentLibrary"
                : "ManageSchoolAssessment";
          } else if (this.account_type === "teacher") {
            this.route_link =
              this.assessment_questions.length === 0
                ? "TeacherContentLibrary"
                : "ManageTeacherAssessment";
          }
        })
        .catch((err) => console.log(err));
    },

    attach() {
      let questions = this.assessment_questions.map((item) => item.id);
      this.isAttaching = true;
      let data = {
        questions,
        class_id: this.getCurrentlySelectHomework.global_class_id,
        subject_id: this.getCurrentlySelectHomework.subject_id,
      };

      // console.log(data)
      this.addQuestionsToHomework({
        homework_id: this.getCurrentlySelectHomework.id,
        data: data,
      })
        .then((res) => {
          this.isAttaching = false;
          if (res.code === 200) {
            this.showAlert(res.message, "success");

            // update homework questions
            let homework_content = JSON.parse(localStorage.homework);
            homework_content.questionCount = res.data.length;
            localStorage.setItem("homework", JSON.stringify(homework_content));
            this.SET_CURRENT_HOMEWORK(homework_content);

            setTimeout(() => this.returnToCreateAssessment(), 3000);
          } else {
            this.showAlert(res.message);
          }
        })
        .catch((err) => {
          this.isAttaching = false;
          this.showAlert(err);
          console.log(err);
        });
    },

    showAlert(msg, type = "error") {
      this.alert = {
        show: true,
        type: type,
        msg: msg,
      };

      setTimeout(() => {
        this.alert = {
          show: false,
          type: "",
          msg: "",
        };
      }, 5000);
    },
  },
};
</script>

<style lang="scss">
.create-question-section {
  .top-section {
    position: fixed;
    background: #fff;
    top: 0;
    z-index: 9;
    width: 100%;
    padding: 11px 0px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);

    @include breakpoint_max(lg) {
      padding: 10px 0px;
    }

    .left {
      .go-back {
        margin-right: 20px;
        font-size: 20px;

        @include breakpoint_max(lg) {
          font-size: 18px;
        }

        @include breakpoint_max(md) {
          margin-right: 10px;
          font-size: 15px;
        }

        @include breakpoint_max(sm) {
          margin-right: 7px;
          margin-left: -12px;
          font-size: 14px;
        }
      }

      .title {
        font-size: 15.5px;

        @include breakpoint_max(sm) {
          font-size: 14px;
        }

        @include breakpoint_max(xs) {
          font-size: 13px;
        }
      }

      .duration {
        font-size: 14px;

        @include breakpoint_max(sm) {
          font-size: 12px;
        }

        @include breakpoint_max(xs) {
          font-size: 11px;
        }
      }
    }
  }

  .content-section-area {
    position: relative;
    margin-top: 110px;
    margin-bottom: 120px;
    // border: 1px solid red;

    @include breakpoint_max(md) {
      margin-top: 90px;
    }

    .container {
      position: relative;
    }

    .selection-row {
      margin-top: 10px;
      margin-bottom: 15px;

      .selection-column {
        position: relative;
        cursor: pointer;
        padding: 12px 24px;
        font-weight: 600;
        font-size: 13px;
        line-height: 18px;
        color: #757575;
        border-radius: 5px;
        background: $border_grey;
        transition: all 0.4s ease-in-out;

        @include breakpoint_max(md) {
          font-size: 11.75px;
          line-height: 16.5px;
          padding: 11px 20px;
          font-weight: 500;
        }

        @include breakpoint_max(xs) {
          font-size: 11px;
          line-height: 15px;
          padding: 10px 18px;
        }

        &:hover {
          background: $brand_navy;
          color: $brand_white;
        }

        &:first-of-type {
          margin-right: 15px;

          @include breakpoint_max(md) {
            margin-right: 10px;
          }

          @include breakpoint_max(sm) {
            margin-right: 5px;
          }
        }
        &:last-of-type {
          margin-left: 15px;

          @include breakpoint_max(md) {
            margin-left: 10px;
          }

          @include breakpoint_max(sm) {
            margin-left: 5px;
          }
        }
      }

      .active-column {
        background: $brand_navy;
        color: $brand_white;

        &:after {
          content: "";
          position: absolute;
          @include equal_min_edge(10);
          left: 50%;
          top: 90%;
          background: $brand_navy;
          transform: translateX(-50%) rotate(45deg);

          @include breakpoint_max(xs) {
            @include equal_min_edge(8);
            top: 88%;
          }
        }
      }
    }

    .top-row {
      margin-top: 40px;
      margin-bottom: 20px;

      .left-row {
        .title-text {
          margin-bottom: 4px;
          font-size: 19px;

          @include breakpoint_max(md) {
            font-size: 17px;
          }

          @include breakpoint_max(sm) {
            font-size: 15px;
          }

          @include breakpoint_max(xs) {
            font-size: 14px;
          }
        }

        .meta-text {
          font-size: 14px;
          line-height: 160%;

          @include breakpoint_max(xl) {
            font-size: 13.5px;
          }

          @include breakpoint_max(md) {
            font-size: 12.5px;
          }

          @include breakpoint_max(sm) {
            font-size: 12px;
          }

          @include breakpoint_max(xs) {
            font-size: 11px;
          }
        }
      }

      .right-row {
        .avatar {
          margin-top: 10px;
          @include equal_min_edge(32);
          transition: all 0.45s ease-in-out;

          @include breakpoint_max(md) {
            @include equal_min_edge(28);

            span {
              font-size: 17px !important;
            }
          }

          &:hover {
            background: $brand_accent !important;
          }
        }
      }
    }
  }

  .bottom-row-section {
    position: fixed;
    background: #fff;
    z-index: 9;
    width: 100%;
    padding: 7px 0px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    bottom: 0;

    .btn {
      font-size: 10.5px;

      @include breakpoint_max(md) {
        font-size: 10px;
      }

      @include breakpoint_max(sm) {
        font-size: 9.5px !important;
        padding: 10px 18px !important;
        font-weight: 500 !important;
      }

      @include breakpoint_max(sm) {
        font-size: 8.75px !important;
        padding: 11px 18px !important;
      }
    }
  }
}
</style>
